export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: 'AIzaSyA4j9AX3ciWMjB_wf7M5sGhiojPNOz8hvk',
    authDomain: 'pruebavocacionalcun.firebaseapp.com',
    projectId: 'pruebavocacionalcun',
    storageBucket: 'pruebavocacionalcun.appspot.com',
    messagingSenderId: '836161970292',
    appId: '1:836161970292:web:02234b877652a4b8337121',
  },
};
